import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserManagementActions, UserManagementApiActions } from './user-management.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { UserManagementService } from '../../services/management/user-management.service';

@Injectable()
export class UserManagementEffects {
    constructor(
        private actions$: Actions,
        private userManagementService: UserManagementService
    ) {}

    loadUsers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserManagementApiActions.loadUsers),
            switchMap(({ request }) =>
                this.userManagementService.loadUsers(request).pipe(
                    map((response) => UserManagementActions.loadUsersSuccess({ response })),
                    catchError((error) => of(UserManagementActions.loadUsersFailure({ error })))
                )
            )
        );
    });

    updateUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserManagementApiActions.updateUser),
            switchMap(({ user, changePassword }) =>
                this.userManagementService.updateUser(user, changePassword).pipe(
                    map((updatedUser) => UserManagementActions.updateUserSuccess({ updatedUser })),
                    catchError((error) => of(UserManagementActions.updateUserFailure({ error })))
                )
            )
        );
    });

    createUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserManagementApiActions.createUser),
            switchMap(({ user, isGuestAccount }) =>
                this.userManagementService.createUser(user, isGuestAccount).pipe(
                    map((newUser) => UserManagementActions.createUserSuccess({ newUser })),
                    catchError((error) => of(UserManagementActions.createUserFailure({ error })))
                )
            )
        );
    });

    deleteUsers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserManagementApiActions.deleteUsers),
            switchMap(({ userIds }) =>
                this.userManagementService.deleteUsers(userIds).pipe(
                    map(() => UserManagementActions.deleteUserSuccess({ userIds })),
                    catchError((error) => of(UserManagementActions.deleteUserFailure({ error })))
                )
            )
        );
    });

    messageToUsers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserManagementApiActions.sendMessage),
            switchMap(({ message }) =>
                this.userManagementService.sendMessageToUsers(message).pipe(
                    map(() => {
                        const userAccountIds = message.userAccountIds;
                        return UserManagementActions.sendMessageSuccess({ userAccountIds });
                    }),
                    catchError((error) => of(UserManagementActions.sendMessageFailure({ error })))
                )
            )
        );
    });
}
